import { Controller } from '@hotwired/stimulus';
import * as bootstrap from 'bootstrap';

export default class extends Controller {
  static targets = ["collapseMenu"]

  autoClose(event) {
    this.collapseMenuTargets.forEach((menu) => {
      if (menu !== event.currentTarget) {
        const bsCollapse = bootstrap.Collapse.getInstance(menu);
        if (bsCollapse && menu.classList.contains('show')) {
          bsCollapse.hide();
        }
      }
    });
  }
}
